import {
  getCountry,
  getcouponstagwise,
  gettagstearwise,
  getAllGroupDataForProductCatalogue,
} from "Listfunction";
import CreateCataloguePackageDetailsForm from "./AddCataloguePackageDetails/AddCataloguePackageDetailsForm";

import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import CataloguePackageFeatureDetailsForm from "./AddCataloguePackageDetails/addCataloguePackageFeatureDetails";
import { getAllSpecialty } from "Listfunction";
import { GetAllDoctors } from "Listfunction";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { addNewPackage } from "Listfunction";
import NotificationSystem from "react-notification-system";
import { useHistory } from "react-router-dom";
import { getPackage } from "Listfunction";
import e from "cors";
import { updatePackage } from "Listfunction";
import ScreenLoader from "views/Components/screenLoader";

const EditCataloguePackage = (props) => {
  const notificationSystemRef = useRef(null);
  const isMounted = useRef(true);
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [countryData, setCountryData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [packageLogo, setPackageLogo] = useState("");
  const [tags, setTags] = useState("");
  const [selectedTiers, setSelectedTiers] = useState("");
  const [selectedTags, setSelectedTags] = useState("");
  const [couponList, setCouponList] = useState([]);
  const [tagListOption, setTagListOption] = useState([]);
  const [packageLogoError, setPackageLogoError] = useState(null);
  const [packageName, setPackageName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [country, setCountry] = useState({ value: "LK", label: "Sri Lanka" });
  const [duration, setDuration] = useState("");
  const [discountPrice, setDiscountPrice] = useState("");
  const [durationType, setDurationType] = useState("");
  const [specialtyListOption, setSpecialtyListOption] = useState([]);
  const [doctorListOption, setDoctorListOption] = useState([]);
  const [deliveryWelcomeNote, setDeliveryWelcomeNote] = useState("");
  const [noOfFreeDelivery, setNoOfFreeDelivery] = useState("");
  const [noOfFreeValue, setNoOfFreeValue] = useState("");
  const [packageLogoUrl, setPackageLogoUrl] = useState("");
  const [oldCompanyLogoFile, setOldCompanyLogoFile] = useState("");
  const [processing, setProcessing] = useState(false);
  const [packageNameError, setPackageNameError] = useState(null);
  const [packageDurationError, setPackageDurationError] = useState(null);
  const [packagePriceError, setPackagePriceError] = useState(null);
  const [countryError, setCountryError] = useState(null);
  const [claimValueError, setClaimValueError] = useState(null);
  const [featureError, setFeatureError] = useState(null);
  const [userType, setUserType] = useState("1");
  const [packageType, setPackageType] = useState("1");
  const [isFeatured, setIsFeatured] = useState("0");
  const [freeTrialType, setFreeTrialType] = useState("");
  const [freeTrial, setFreeTrial] = useState("");
  const [packagePrice, setPackagePrice] = useState("");
  const [oldPolicyDetails, setOldPolicyDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deletedPolicyIds, setDeletedPolicyIds] = useState([]);
  const [featureDetails, setFeatureDetails] = useState([
    {
      id: 6,
      chk_value: 6,
      label: "Medicine",
      checked: false,
      placeholder: "Enter Discount",
      name: "medicine_discount",
      input_value: "",
      errorMessage: "Medicine discount is required.",
      isFlashCredit: false,
    },
    {
      id: 3,
      chk_value: 3,
      label: "Lab",
      checked: false,
      placeholder: "Enter Discount",
      name: "lab_discount",
      input_value: "",
      errorMessage: "Lab Discount is required.",
      isFlashCredit: false,
    },
    // {
    //   id: 2,
    //   chk_value: 2,
    //   label: "Raya",
    //   checked: false,
    //   placeholder: "Enter Discount",
    //   name: "raya_flat_discount",
    //   input_value: "",
    //   errorMessage: "Raya Discount is required.",
    //   isFlashCreditRaya: true,
    // },
    {
      id: 4,
      chk_value: 4,
      label: "MBE",
      checked: false,
      placeholder: "MBE Price",
      name: "mbe_price",
      input_value: "",
      errorMessage: "MBE Price is required.",
    },
    {
      id: 1,
      chk_value: 1,
      label: "Talk now",
      checked: false,
      placeholder: "Talk now",
      name: "no_of_calls",
      input_value: "",
      errorMessage: "Talk now is required.",
      unlimited: false,
      isFlashCredit: false,
    },
    {
      id: 10,
      chk_value: 10,
      label: "Talk global",
      checked: false,
      placeholder: "Talk global ",
      name: "no_of_talk_global_calls",
      input_value: "",
      errorMessage: "Talk Later Global is required.",
      unlimited: false,
      isFlashCredit: false,
    },
    {
      id: 11,
      chk_value: 11,
      label: "Talk later",
      checked: false,
      placeholder: "Talk later",
      name: "no_of_talk_later_calls",
      input_value: "",
      errorMessage: "Talk Later is required.",
      unlimited: false,
      isFlashCredit: false,
    },
    {
      id: 8,
      chk_value: 8,
      label: "Talk later speciality",
      checked: false,
      placeholder: "Talk later",
      name: "no_of_calls_talk_later",
      input_value: [{ specialty: "", noOfCalls: "" }],
      unlimited: false,
      errorMessage: "Talk later is required.",
    },
    {
      id: 5,
      chk_value: 5,
      label: "Delivery",
      checked: false,
      placeholder: "N.O Deliveries",
      name: "delivery",
      input_value: [
        {
          type: "standard",
          free: null,
          discount: null,
          base_price: null,
        },
        {
          type: "express",
          free: null,
          discount: null,
          base_price: null,
        },
        {
          type: "island_wide",
          free: null,
          discount: null,
          base_price: null,
        },
      ],
      errorMessage: "N.O Delivery is required.",
      standard: false,
      express: false,
      islandWide: false,
    },
    // {
    //   id: 7,
    //   chk_value: 7,
    //   label: "Insurance",
    //   checked: false,
    //   placeholder: "N.O Insurance",
    //   name: "no_of_insurance_order",
    //   input_value: [],
    //   addresslist: [],
    //   errorMessage: "N.O Insurance order is required.",
    // },
    {
      id: 9,
      chk_value: 9,
      label: "Partner & Coupon Management",
      checked: false,
      placeholder: "Partner & Coupon Management",
      name: "partner_and_coupon_management",
      value: [],
      errorMessage: "Partner & Coupon Management is required.",
    },
    {
      id: 12,
      chk_value: 12,
      label: "MBE Groups",
      checked: false,
      placeholder: "Select Group",
      name: "group",
      value: [],
      errorMessage: "Group is required.",
    },
    {
      id: 13,
      chk_value: 13,
      label: "Claim Module",
      checked: false,
      name: "claim",
      value: [],
      errorMessage: "Claim is required.",
    },
    {
      id: 14,
      chk_value: 14,
      label: "Talk Later Doctor wise",
      checked: false,
      name: "talkLaterDoctorWise",
      input_value: [],
      errorMessage: "Talk later doctor is required.",
    },
  ]);
  const packageId = useMemo(() => localStorage.getItem("packageId"), []);

  const fetchCountryData = useCallback(async () => {
    try {
      const response = await getCountry(obj);
      return response.data;
    } catch (error) {
      console.error("Error fetching country data:", error);
      return [];
    }
  }, [obj]);

  const getPackageDataById = useCallback(
    async (countriesData, specialties, doctors, groupsData) => {
      const packageId = localStorage.getItem("packageId");

      try {
        const response = await getPackage(packageId, obj);
        let packageData = response.data.data;

        let p_feature =
          typeof response.data.data.packageFeatures === "string"
            ? JSON.parse(response.data.data.packageFeatures)
            : response.data.data.packageFeatures;
        let list = [...featureDetails];
        let policy = packageData.policy;

        if (isMounted.current) {
          setPackageName(packageData.title);
          setProductCode(packageData.product_code);
          setPackagePrice(packageData.price);
          setDuration(packageData.duration);
          setDurationType(packageData.duration_type);
          setPackageLogoUrl(packageData.package_logo);
          setUserType(packageData.user_type.toString());
          setPackageType(packageData.package_type.toString());
        }
        if (countriesData && countriesData.length > 0) {
          const foundCountry = countriesData.find(
            (data) => data.country_code === packageData.country_code,
          );
          if (isMounted.current) {
            setCountry({
              value: packageData.country_code,
              label:
                foundCountry && foundCountry.country_name
                  ? foundCountry.country_name
                  : packageData.country_code,
            });
          }
        } else {
          if (isMounted.current) {
            setCountry({
              value: packageData.country_code,
              label: packageData.country_code,
            });
          }
        }
        if (isMounted.current) {
          setIsFeatured(packageData.is_featured.toString());
          setUserType(packageData.user_type.toString());
          setPackageType(packageData.package_type.toString());
          setFreeTrialType(packageData.free_trial_type);
          setFreeTrial(packageData.free_trial);
          setDiscountPrice(packageData.discount_price);
        }
        p_feature.sort((a, b) => (a.category_id > b.category_id ? 1 : -1));
        for (let i = 0; i < list.length; i++) {
          for (let j = 0; j < p_feature.length; j++) {
            if (list[i].chk_value == p_feature[j].category_id) {
              if (p_feature[j].value) {
                if (p_feature[j].category_id == "8") {
                  if (JSON.parse(p_feature[j].value).length > 0) {
                    list[i].input_value = JSON.parse(p_feature[j].value).map(
                      (item) => {
                        const foundSpec =
                          specialties &&
                          specialties.find(
                            (spec) => spec.value === item.speciality_id,
                          );
                        return {
                          specialty: {
                            value: item.speciality_id,
                            label: foundSpec
                              ? foundSpec.label
                              : item.speciality_id,
                          },
                          noOfCalls: item.no_of_calls,
                          unlimited:
                            item.no_of_calls == "unlimited" ? true : false,
                        };
                      },
                    );
                    list[i].checked = true;
                  }
                } else if (p_feature[j].category_id == "5") {
                  let deliveryValues =
                    typeof p_feature[j].value === "string"
                      ? JSON.parse(p_feature[j].value)
                      : p_feature[j].value;
                  let standardEnabled = false;
                  let expressEnabled = false;
                  let islandWideEnabled = false;

                  // Set checked to true if delivery exists in API response

                  for (let xi = 0; xi < deliveryValues.length - 1; xi++) {
                    if (
                      (deliveryValues[xi].free !== 0 &&
                        deliveryValues[xi].free !== null &&
                        deliveryValues[xi].free !== "") ||
                      (deliveryValues[xi].discount !== 0 &&
                        deliveryValues[xi].discount !== null &&
                        deliveryValues[xi].discount !== "") ||
                      (deliveryValues[xi].base_price !== 0 &&
                        deliveryValues[xi].base_price !== null &&
                        deliveryValues[xi].base_price !== "")
                    ) {
                      if (xi === 0) {
                        standardEnabled = true;
                      } else if (xi === 1) {
                        expressEnabled = true;
                      } else if (xi === 2) {
                        islandWideEnabled = true;
                      }
                      list[i]["checked"] = true;
                    }
                  }

                  let standardObj = deliveryValues.find(
                    (item) => item.type == "standard",
                  );
                  let expressObj = deliveryValues.find(
                    (item) => item.type == "express",
                  );
                  let islandWideObj = deliveryValues.find(
                    (item) => item.type == "island_wide",
                  );

                  if (standardObj) {
                    list[i].input_value[0] = {
                      type: "standard",
                      free: standardObj.free,
                      discount: standardObj.discount,
                      base_price: standardObj.base_price,
                      enabled: standardEnabled,
                    };
                  }
                  if (expressObj) {
                    list[i].input_value[1] = {
                      type: "express",
                      free: expressObj.free,
                      discount: expressObj.discount,
                      base_price: expressObj.base_price,
                      enabled: expressEnabled,
                    };
                  }
                  if (islandWideObj) {
                    list[i].input_value[2] = {
                      type: "island_wide",
                      free: islandWideObj.free,
                      discount: islandWideObj.discount,
                      base_price: islandWideObj.base_price,
                      enabled: islandWideEnabled,
                    };
                  }
                  let sumObj = deliveryValues.find(
                    (item) => item.type === "sum",
                  );
                  if (sumObj && isMounted.current) {
                    setNoOfFreeDelivery(sumObj.t_count);
                    list[i].noOfFreeDelivery = sumObj.t_count;
                  }
                } else if (p_feature[j].category_id == "9") {
                  if (JSON.parse(p_feature[j].value).length > 0) {
                    list[i].value = JSON.parse(p_feature[j].value);
                    const arrangeCoupon = p_feature[j].coupons.map((coupon) => {
                      return {
                        id: coupon.id,
                        title: coupon.title,

                        label: coupon.title,
                      };
                    });
                    list[i].selectedCoupons = arrangeCoupon;
                    list[i].checked = true;
                  }
                } else if (p_feature[j].category_id == "12") {
                  if (JSON.parse(p_feature[j].value).length > 0) {
                    const arrangeGroup = JSON.parse(p_feature[j].value)
                      .map((group) => {
                        const foundGroup =
                          groupsData &&
                          groupsData.find(
                            (groupItem) =>
                              String(groupItem.id) === String(group),
                          );
                        return foundGroup;
                      })
                      .filter((item) => item !== null && item !== undefined);
                    list[i].value = arrangeGroup;
                    list[i].checked = true;
                  }
                } else if (p_feature[j].category_id == "13") {
                  if (JSON.parse(p_feature[j].value).length > 0) {
                    let claimValues = JSON.parse(p_feature[j].value)[0];
                    list[i].claimValue = claimValues.value;
                    list[i].ipdClaimValue = claimValues.ipdClaimValue;
                    list[i].isClaimMedicine = claimValues.medicine;
                    list[i].isClaimLab = claimValues.lab;
                    list[i].isClaimRaya = claimValues.raya;
                    list[i].isClaimTalkNow = claimValues.talkNow;
                    list[i].isClaimTalkLater = claimValues.talkLater;
                    list[i].isClaimTalkGlobal = claimValues.talkGlobal;
                    list[i].isClaimEchanneling = claimValues.echanneling;
                    list[i].isClaimFamily = claimValues.talkFamily;
                    list[i].isClaimFather = claimValues.talkFamilyFather;
                    list[i].isClaimMother = claimValues.talkFamilyMother;
                    list[i].isClaimSpouse = claimValues.talkFamilySpouse;
                    list[i].isClaimChild = claimValues.talkFamilyChild;
                    list[i].isClaimBrother = claimValues.talkFamilyBrother;
                    list[i].isClaimSister = claimValues.talkFamilySister;
                    list[i].creditType = claimValues.creditType;
                    list[i].opdIndividualPrice = claimValues.opdIndividual;
                    list[i].opdFamilyPrice = claimValues.opdFamilyPrice;
                    list[i].claimBillingCycle = claimValues.billingCycle;
                    list[i].isUnlimitedClaim =
                      claimValues.isUnlimitedAllocation;
                    list[i].isSystemClaimAllowed =
                      claimValues.isSystemClaimAllowed;
                    list[i].isBankAccountNeeded =
                      claimValues.isBankAccountNeeded;
                    list[i].isHospitalization = claimValues.hospitalization;
                    list[i].poolValue = claimValues.poolValue;
                    list[i].claimType = claimValues.claimType;
                    list[i].checked = true;
                    list[i].pharma =
                      claimValues.manualClaims &&
                      claimValues.manualClaims.find((item) => item == "Pharma")
                        ? "Pharma"
                        : "";
                    list[i].lab =
                      claimValues.manualClaims &&
                      claimValues.manualClaims.find((item) => item == "Lab")
                        ? "Lab"
                        : "";
                    list[i].consult =
                      claimValues.manualClaims &&
                      claimValues.manualClaims.find((item) => item == "Consult")
                        ? "Consult"
                        : "";
                    list[i].hospital =
                      claimValues.manualClaims &&
                      claimValues.manualClaims.find(
                        (item) => item == "Hospital",
                      )
                        ? "Hospital"
                        : "";

                    if (policy && policy.length > 0) {
                      let deletedPolicyId = [];
                      policy.map((data) => {
                        const contentBlock = htmlToDraft(data.policy);
                        const contentState = ContentState.createFromBlockArray(
                          contentBlock.contentBlocks,
                        );
                        const editorState =
                          EditorState.createWithContent(contentState);
                        if (data.type_title === "medicine") {
                          list[i].claimPolicyDetails = {
                            id: data.id,
                            title: data.type_title,
                            value: editorState,
                            isOldClaimPolicy: true,
                          };
                        }
                        deletedPolicyId.push(data.id);
                      });
                      setDeletedPolicyIds(deletedPolicyId);
                    }
                  }
                  if (isMounted.current) {
                    setOldPolicyDetails(policy);
                  }
                } else if (p_feature[j].category_id == "14") {
                  const pcvalue = [];
                  const doctorPayload =
                    typeof p_feature[j].value === "string"
                      ? JSON.parse(p_feature[j].value)
                      : p_feature[j].value;

                  if (
                    Array.isArray(doctorPayload) &&
                    doctorPayload.length > 0
                  ) {
                    for (let xi = 0; xi < doctorPayload.length; xi++) {
                      const payloadItem = doctorPayload[xi];
                      const doctorIdVal = payloadItem
                        ? payloadItem.doctorId
                        : "";
                      const matchedDoctor = Array.isArray(doctors)
                        ? doctors.find(
                            (data) =>
                              String(data.value) === String(doctorIdVal),
                          )
                        : null;

                      const doctorObj = matchedDoctor
                        ? matchedDoctor
                        : { value: doctorIdVal, label: doctorIdVal };

                      pcvalue.push({
                        doctors: doctorObj,
                        no_of_calls: payloadItem ? payloadItem.noOfCalls : "",
                      });
                    }

                    list[i]["input_value"] = pcvalue;
                    list[i]["checked"] = true;
                  }
                } else {
                  if (
                    p_feature[j].category_id == "1" &&
                    (p_feature[j].value == "unlimited" ||
                      p_feature[j].value == "Unlimited")
                  ) {
                    list[i]["unlimited"] = true;
                  }
                  if (
                    p_feature[j].category_id == "1" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCredit"] = true;
                  }
                  if (
                    p_feature[j].category_id == "10" &&
                    (p_feature[j].value == "unlimited" ||
                      p_feature[j].value == "Unlimited")
                  ) {
                    list[i]["unlimited"] = true;
                  }
                  if (
                    p_feature[j].category_id == "10" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCredit"] = true;
                  }
                  if (
                    p_feature[j].category_id == "11" &&
                    (p_feature[j].value == "unlimited" ||
                      p_feature[j].value == "Unlimited")
                  ) {
                    list[i]["unlimited"] = true;
                  }
                  if (
                    p_feature[j].category_id == "11" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCredit"] = true;
                  }
                  if (
                    p_feature[j].category_id == "6" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCredit"] = true;
                  }
                  if (
                    p_feature[j].category_id == "3" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCredit"] = true;
                  }
                  if (
                    p_feature[j].category_id == "2" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCredit"] = true;
                  }
                  list[i]["input_value"] = p_feature[j].value;
                  list[i]["checked"] = true;
                }
              }
            }
          }
        }
        if (isMounted.current) {
          setFeatureDetails(list);
        }
      } catch (error) {
        console.error("Error fetching package data:", error);
      }
    },
    [obj],
  );

  console.log("Features", featureDetails);
  console.log("userType", userType);

  const fetchGroupData = useCallback(async () => {
    try {
      const response = await getAllGroupDataForProductCatalogue(obj);
      const data = response.data;
      const groups = data && data.data ? data.data : data;
      return Array.isArray(groups) ? groups : [];
    } catch (error) {
      console.error("Error fetching group data:", error);
      return [];
    }
  }, [obj]);

  const addSpecialtyRow = (index) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index].input_value.push({
      specialty: "",
      noOfCalls: "",
    });
    setFeatureDetails(updatedFeatures);
  };

  const onChangeTags = async (event) => {
    const value = event.target.value;

    setSelectedTags(value);
    if (!obj) return;

    try {
      const res = await getcouponstagwise(value, selectedTiers, obj);
      const data = res.data || {};
      const couponOptions = Array.isArray(data.coupons)
        ? data.coupons.map((c) => ({ id: c.id, title: c.title }))
        : [];
      setCouponList(couponOptions);
    } catch (err) {
      console.error("Error fetching coupons by tag", err);
    }
  };

  const onChangeTier = async (event) => {
    const value = event.target.value;
    setSelectedTiers(value);
    if (!obj) return;

    try {
      const res = await gettagstearwise(value, obj);
      const data = res.data;
      const tagOptions = Array.isArray(data.tags)
        ? data.tags.map((x) => ({ value: x, label: x }))
        : [];
      setTagListOption(tagOptions);
    } catch (err) {
      console.error("Error fetching tags by tier", err);
    }
  };

  const uploadPackageLogo = () => {
    document.getElementById("selectpackage_logo").click();
  };

  const handlePackageLogoFileChange = (event) => {
    setPackageLogo(event.target.files[0]);
    setPackageLogoError(null);
  };

  const getAllSpecialties = useCallback(async () => {
    try {
      const specialties = await getAllSpecialty(obj);
      const specialityOptions = specialties.data.data.map((spec) => ({
        value: spec.id,
        label: spec.title,
      }));
      return specialityOptions;
    } catch (error) {
      console.error("Error fetching specialties:", error);
      return [];
    }
  }, [obj]);

  const getAllDoctors = useCallback(async () => {
    try {
      const response = await GetAllDoctors(obj);
      const mdata = response.data.data;
      const doctorOptions = mdata.map((data) => ({
        value: data.id,
        label: data.name,
      }));
      return doctorOptions;
    } catch (error) {
      console.error("Error fetching doctors:", error);
      return [];
    }
  }, [obj]);

  const onSpecialityChange = (value, i, idx) => {
    const updatedFeatures = [...featureDetails];
    // Store the entire selected object for react-select
    updatedFeatures[i].input_value[idx].specialty = value;
    setFeatureDetails(updatedFeatures);
  };

  const onCallChange = (e, i, idx) => {
    const re = /^\d*$/;

    if (re.test(e.target.value)) {
      const updatedFeatures = [...featureDetails];
      updatedFeatures[i].input_value[idx].noOfCalls = e.target.value;
      setFeatureDetails(updatedFeatures);
    }
  };

  const handleAllCheckedFreeDelivery = (checked, i) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[i].checked = checked;

    if (!checked) {
      updatedFeatures[i].input_value = [
        {
          type: "standard",
          free: null,
          discount: null,
          base_price: null,
        },
        {
          type: "express",
          free: null,
          discount: null,
          base_price: null,
        },
        {
          type: "islandWide",
          free: null,
          discount: null,
          base_price: null,
        },
      ];
      updatedFeatures[i].more = false;
      updatedFeatures[i].standard = false;
      updatedFeatures[i].express = false;
      updatedFeatures[i].islandWide = false;
      setDeliveryWelcomeNote("");
      setNoOfFreeDelivery("");
    }

    setFeatureDetails(updatedFeatures);
    setNoOfFreeValue("");
  };

  // Partner & Coupon Management functions
  const onCouponAdd = (e, index) => {
    const value = e.target.value;
    if (!value) return;

    const updatedFeatures = [...featureDetails];
    const feature = updatedFeatures[index];
    const selectedCoupons = Array.isArray(feature.selectedCoupons)
      ? feature.selectedCoupons
      : [];

    const existing = selectedCoupons.some(
      (c) => String(c.id) === String(value),
    );
    if (existing) {
      e.target.value = "";
      return;
    }

    const found = couponList.find((c) => String(c.id) === String(value));
    const optionText =
      e.target.options && e.target.selectedIndex >= 0
        ? e.target.options[e.target.selectedIndex].text
        : "";

    const entry = found
      ? {
          ...found,
          label: found.label || found.title || optionText || value.toString(),
          title: found.title || found.label || optionText || value.toString(),
        }
      : {
          id: value,
          title: optionText || value.toString(),
          label: optionText || value.toString(),
        };

    const list = [...selectedCoupons];
    list.push(entry);
    updatedFeatures[index].selectedCoupons = list;

    setFeatureDetails(updatedFeatures);
    e.target.value = "";
  };

  const onRemoveCoupon = (id, index) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index].selectedCoupons = (
      updatedFeatures[index].selectedCoupons || []
    ).filter((c) => String(c.id) !== String(id));
    setFeatureDetails(updatedFeatures);
  };

  // MBE Groups functions
  const onGroupAdd = (e, index) => {
    const value = e.target.value;
    if (!value) return;

    const updatedFeatures = [...featureDetails];
    const selectedGroups = Array.isArray(updatedFeatures[index].value)
      ? updatedFeatures[index].value
      : [];

    const exists = selectedGroups.some((g) => String(g.id) === String(value));
    if (exists) {
      e.target.value = "";
      return;
    }

    const match = groupData.find((g) => String(g.id) === String(value));
    const optionText =
      e.target.options && e.target.selectedIndex >= 0
        ? e.target.options[e.target.selectedIndex].text
        : "";

    const entry = match || {
      id: value,
      group_name: optionText || value.toString(),
    };

    const list = [...selectedGroups];
    list.push(entry);
    updatedFeatures[index].value = list;

    setFeatureDetails(updatedFeatures);
    e.target.value = "";
  };

  const onGroupRemove = (id, index) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index].value = (updatedFeatures[index].value || []).filter(
      (g) => String(g.id) !== String(id),
    );
    setFeatureDetails(updatedFeatures);
  };

  // Claim Module functions
  const updateClaimField = (index, field, value) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index] = {
      ...updatedFeatures[index],
      [field]: value,
    };
    setFeatureDetails(updatedFeatures);
  };

  // Handle policy change - includes edit mode detection
  const updatePolicyField = (index, type, editorState) => {
    const updatedFeatures = [...featureDetails];
    const feature = updatedFeatures[index];

    // Check if this is edit mode (oldPolicyDetails exists)
    const isEditMode = true;

    if (type === "medicine") {
      if (isEditMode) {
        // Edit mode: Compare old and new policy
        const medicinePolicy = oldPolicyDetails.find(
          (data) => data.type_title === "medicine",
        );
        const oldPolicyData = medicinePolicy ? medicinePolicy.policy : "";
        const currentPolicyData = editorState
          ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
          : "";

        if (medicinePolicy && oldPolicyData !== currentPolicyData) {
          feature.claimPolicyDetails = {
            id: medicinePolicy.id,
            title: type,
            value: editorState,
            isUpdated: true,
          };
        } else {
          feature.claimPolicyDetails = {
            id: medicinePolicy ? medicinePolicy.id : null,
            title: type,
            value: editorState,
            isUpdated: false,
          };
          setDeletedPolicyIds([]);
        }
      } else {
        // Add mode: No comparison needed
        feature.claimPolicyDetails = {
          title: type,
          value: editorState,
          isUpdated: false,
        };
        setDeletedPolicyIds([]);
      }
    }

    setFeatureDetails(updatedFeatures);
  };

  const toggleClaimCheckbox = (index, field, checked) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index] = {
      ...updatedFeatures[index],
      [field]: checked,
    };
    if (field === "isUnlimitedClaim" && checked) {
      updatedFeatures[index].claimValue = "";
    }
    setFeatureDetails(updatedFeatures);
  };

  // Talk Later Doctor wise functions
  const onDoctorChange = (selected, index, docIdx) => {
    const updatedFeatures = [...featureDetails];
    if (
      updatedFeatures[index].input_value &&
      updatedFeatures[index].input_value[docIdx]
    ) {
      updatedFeatures[index].input_value[docIdx].doctors = selected;
    }
    setFeatureDetails(updatedFeatures);
  };

  const onDoctorCallChange = (e, index, docIdx) => {
    if (e.target.value === "" || /^[0-9\b]+$/.test(e.target.value)) {
      const updatedFeatures = [...featureDetails];
      if (
        updatedFeatures[index].input_value &&
        updatedFeatures[index].input_value[docIdx]
      ) {
        updatedFeatures[index].input_value[docIdx].no_of_calls = e.target.value;
      }
      setFeatureDetails(updatedFeatures);
    }
  };

  const addDoctorRow = (index) => {
    const updatedFeatures = [...featureDetails];
    const list = Array.isArray(updatedFeatures[index].input_value)
      ? [...updatedFeatures[index].input_value]
      : [];
    list.push({ doctors: null, no_of_calls: "" });
    updatedFeatures[index].input_value = list;
    setFeatureDetails(updatedFeatures);
  };

  const removeDoctorRow = (index, rowIndex) => {
    const updatedFeatures = [...featureDetails];
    const inputArray = Array.isArray(updatedFeatures[index].input_value)
      ? [...updatedFeatures[index].input_value]
      : [];
    const filteredRows = inputArray.filter((item, idx) => idx !== rowIndex);
    updatedFeatures[index].input_value =
      filteredRows.length > 0 ? filteredRows : [];
    setFeatureDetails(updatedFeatures);
  };

  const removeSpecialtyRow = (index, rowIndex) => {
    const updatedFeatures = [...featureDetails];
    const inputArray = Array.isArray(updatedFeatures[index].input_value)
      ? [...updatedFeatures[index].input_value]
      : [];

    // Filter out the row at the specified rowIndex
    const filteredRows = inputArray.filter((item, idx) => idx !== rowIndex);

    // If no rows remain, reset to initial state with one empty row
    updatedFeatures[index].input_value =
      filteredRows.length > 0
        ? filteredRows
        : [{ specialty: "", noOfCalls: "" }];

    setFeatureDetails(updatedFeatures);
  };

  const onSubmit = async () => {
    let logoUrlToUse = packageLogoUrl; // Start with existing URL

    try {
      if (packageLogo && packageLogo.length !== 0) {
        setProcessing(true);
        const fdata = new FormData();
        fdata.append("company_logo", packageLogo);

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/comapany/logo";
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "X-Request-Id": "124",
          },
          body: fdata,
        });

        const res = await response.json();
        if (res.data && res.data.company_logo_url) {
          logoUrlToUse = res.data.company_logo_url;
          setPackageLogoUrl(logoUrlToUse);
        }
        setProcessing(false);
      }
    } catch (error) {
      console.error("Logo upload error:", error);
      setProcessing(false);
    }

    let error = false;
    if (!packageName || packageName.length === 0) {
      error = true;
      setPackageNameError(
        <small className="text-danger">Package Name is required.</small>,
      );
    } else {
      setPackageNameError(null);
    }

    if (!duration || duration.length === 0) {
      error = true;
      setPackageDurationError(
        <small className="text-danger">Duration is required.</small>,
      );
    } else {
      setPackageDurationError(null);
    }

    if (!packagePrice || packagePrice.length === 0) {
      error = true;
      setPackagePriceError(
        <small className="text-danger">Price is required.</small>,
      );
    } else {
      setPackagePriceError(null);
    }

    if (!country || country === "0") {
      error = true;
      setCountryError(
        <small className="text-danger">Country is required.</small>,
      );
    } else {
      setCountryError(null);
    }

    // Only require logo if it's a new package (no packageId in localStorage means new)
    // For edit mode, existing logo is fine if no new one is uploaded
    const isNewPackage = !localStorage.getItem("packageId");

    if (isNewPackage && !packageLogo) {
      error = true;
      setPackageLogoError(
        <small className="text-danger">Package logo is required.</small>,
      );
    } else {
      setPackageLogoError(null);
    }

    const hasCheckedFeature = featureDetails.some((f) => f.checked);
    if (!hasCheckedFeature) {
      error = true;
      setFeatureError(
        <small className="text-danger">
          At least one feature is required.
        </small>,
      );
    } else {
      setFeatureError(null);
    }

    const getClaimFeatureData = featureDetails.find(
      (data) => data.chk_value === 13,
    );
    if (getClaimFeatureData && getClaimFeatureData.checked) {
      if (
        (!getClaimFeatureData.claimValue ||
          getClaimFeatureData.claimValue === "") &&
        !getClaimFeatureData.isUnlimitedClaim
      ) {
        error = true;
        setClaimValueError(
          <small className="text-danger">
            Claim allocation or unlimited claim is required.
          </small>,
        );
      } else {
        setClaimValueError(null);
      }
    }

    if (!error) {
      const featureData = [];
      const payload = featureDetails.map((feature) => {
        if (feature.name == "no_of_calls_talk_later") {
          if (feature.checked) {
            let talkLaterSpeciality = [];
            for (let xi = 0; xi < feature.input_value.length; xi++) {
              let specialtyId = feature.input_value[xi].specialty
                ? feature.input_value[xi].specialty.value
                : "";

              talkLaterSpeciality.push({
                speciality_id: specialtyId,
                no_of_calls: feature.input_value[xi].noOfCalls,
              });
            }
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: talkLaterSpeciality,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else if (feature.name === "delivery") {
          const deliveryOptions = feature.input_value.map((option) => ({
            type: option.type,
            free: option.free,
            discount: option.discount,
            base_price: option.base_price,
          }));
          deliveryOptions.push({
            type: "sum",
            t_count: noOfFreeDelivery,
          });
          let deliveryPayload = deliveryOptions;
          featureData.push({
            category_id: feature.chk_value,
            title: feature.name,
            value: deliveryPayload,
          });
        } else if (feature.name === "claim") {
          if (feature.checked) {
            const manualClaimFeature = [
              feature.pharma && feature.pharma !== "" ? feature.pharma : null,
              feature.lab && feature.lab !== "" ? feature.lab : null,
              feature.consult && feature.consult !== ""
                ? feature.consult
                : null,
              feature.hospital && feature.hospital !== ""
                ? feature.hospital
                : null,
            ].filter((item) => item !== null);
            const policyDetails =
              feature.claimPolicyDetails &&
              feature.claimPolicyDetails.value &&
              typeof feature.claimPolicyDetails.value.getCurrentContent ===
                "function"
                ? draftToHtml(
                    convertToRaw(
                      feature.claimPolicyDetails.value.getCurrentContent(),
                    ),
                  )
                : "";

            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [
                {
                  value: feature.claimValue,
                  medicine: feature.isClaimMedicine || false,
                  lab: feature.isClaimLab || false,
                  raya: feature.isClaimRaya || false,
                  talkNow: feature.isClaimTalkNow || false,
                  talkLater: feature.isClaimTalkLater || false,
                  talkGlobal: feature.isClaimTalkGlobal || false,
                  eChanneling: feature.isClaimEchanneling || false,
                  hospitalization: feature.isHospitalization || false,
                  talkFamily: feature.isClaimFamily || false,
                  talkFamilyMother:
                    (feature.isClaimFamily && feature.isClaimMother) || false,
                  talkFamilyFather:
                    (feature.isClaimFamily && feature.isClaimFather) || false,
                  talkFamilyBrother:
                    (feature.isClaimFamily && feature.isClaimBrother) || false,
                  talkFamilySister:
                    (feature.isClaimFamily && feature.isClaimSister) || false,
                  talkFamilySpouse:
                    (feature.isClaimFamily && feature.isClaimSpouse) || false,
                  talkFamilyChild:
                    (feature.isClaimFamily && feature.isClaimChild) || false,
                  creditType: 4,
                  opdIndividual: feature.opdIndividualPrice,
                  opdFamilyPrice: feature.opdFamilyPrice,
                  billingCycle: feature.claimBillingCycle,
                  isUnlimitedAllocation: feature.isUnlimitedClaimAllocation,
                  isSystemClaimAllowed: feature.isSystemClaimAllowed,
                  isBankAccountNeeded: feature.isBankAccountNeeded,
                  poolValue: feature.poolValue,
                  manualClaims: manualClaimFeature,
                  claimType: feature.claimType,
                  ipdClaimValue: feature.ipdClaimValue,
                },
              ],
              policy: policyDetails,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
              policy: [],
            });
          }
        } else if (feature.name === "talkLaterDoctorWise") {
          if (
            feature.checked &&
            feature.input_value &&
            feature.input_value.length > 0
          ) {
            const selectedDoctorId = feature.input_value.map((item) => {
              return {
                doctorId:
                  item.doctors && item.doctors.value
                    ? item.doctors.value
                    : null,
                noOfCalls: item.no_of_calls,
              };
            });
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: selectedDoctorId,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else if (feature.name === "group") {
          if (feature.checked && feature.value && feature.value.length > 0) {
            const selectedGroupId = feature.value.map((group) => group.id);
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: selectedGroupId,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else if (feature.name === "partner_and_coupon_management") {
          if (
            feature.checked &&
            feature.selectedCoupons &&
            feature.selectedCoupons.length > 0
          ) {
            const selectedCouponId = feature.selectedCoupons.map(
              (coupon) => coupon.id,
            );
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: selectedCouponId,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else {
          if (feature.checked) {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: feature.value || feature.input_value,
              is_flash_credit_usable: feature.isFlashCredit || false,
              unlimited: feature.unlimited || false,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: "",
            });
          }
        }
      });
      const getPolicy = featureDetails.find(
        (feature) => feature.name === "claim" && feature.claimPolicyDetails,
      );
      let policyPayload = [];
      const xxx = featureDetails.map((feature) => {
        if (
          feature.name === "claim" &&
          feature.claimPolicyDetails &&
          feature.checked &&
          getPolicy
        ) {
          if (feature.isClaimMedicine) {
            policyPayload.push({
              title: "medicine",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
          if (feature.isClaimLab) {
            policyPayload.push({
              title: "lab",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
          if (feature.isClaimRaya) {
            policyPayload.push({
              title: "raya",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
          if (feature.isClaimTalkNow) {
            policyPayload.push({
              title: "talkNow",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
          if (feature.isClaimTalkLater) {
            policyPayload.push({
              title: "talkLater",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
        }
      });

      setIsLoading(true);
      await updatePackage(
        packageName,
        "",
        duration,
        durationType,
        packagePrice,
        "#00A651",
        featureData,
        "",
        "",
        Number(userType),
        Number(packageType),
        isFeatured,
        freeTrial,
        freeTrialType,
        discountPrice,
        productCode,
        country.value,
        logoUrlToUse,
        policyPayload,
        deletedPolicyIds,
        obj,
        packageId,
      )
        .then((res) => {
          if (res.data.success === true) {
            handleSuccess("bl");
          }
        })
        .catch((error) => {
          console.log(error, "== error");
          handleNetworkError("bl");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleSuccess = (position) => {
    if (notificationSystemRef.current) {
      notificationSystemRef.current.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Catalogue Package</b> - Updated Successfully.
          </div>
        ),
        level: "success",
        position: position,
        autoDismiss: 15,
      });
      setTimeout(() => {
        props.history.push("/admin/productcatalogue");
      }, 500);
    }
  };

  const handleNetworkError = (position) => {
    if (notificationSystemRef.current) {
      notificationSystemRef.current.addNotification({
        title: <span data-notify="icon" className="pe-7s-close"></span>,
        message: (
          <div>
            <b>Error</b> - Failed to create package.
          </div>
        ),
        level: "error",
        position: position,
        autoDismiss: 15,
      });
    }
  };

  useEffect(() => {
    isMounted.current = true;
    const loadData = async () => {
      setIsLoading(true);
      try {
        // Load all data in parallel for better performance
        const [countries, groups, specialties, doctors] = await Promise.all([
          fetchCountryData(),
          fetchGroupData(),
          getAllSpecialties(),
          getAllDoctors(),
        ]);

        if (isMounted.current) {
          setCountryData(countries);
          setGroupData(groups);
          setSpecialtyListOption(specialties);
          setDoctorListOption(doctors);

          // Load package data after all reference data is loaded
          await getPackageDataById(countries, specialties, doctors, groups);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        if (isMounted.current) {
          setIsLoading(false);
        }
      }
    };
    loadData();

    return () => {
      isMounted.current = false;
    };
  }, []);

  const onCallUnlimitedChange = (e, index, specIndex) => {
    const updated = [...featureDetails];
    const item = {
      ...updated[index].input_value[specIndex],
    };
    item.unlimited = e.target.checked;
    if (e.target.checked) {
      item.noOfCalls = "unlimited";
    } else {
      item.noOfCalls = "";
    }
    updated[index].input_value[specIndex] = item;
    setFeatureDetails(updated);
  };

  // Remove the second useEffect as we're loading everything in parallel now

  return (
    <>
      <NotificationSystem ref={notificationSystemRef} />
      {isLoading && <ScreenLoader />}
      <CreateCataloguePackageDetailsForm
        countryData={countryData}
        groupData={groupData}
        packageLogo={packageLogo}
        packageLogoUrl={packageLogoUrl}
        isEditMode={true}
        packageLogoError={packageLogoError}
        uploadPackageLogo={uploadPackageLogo}
        handlePackageLogoFileChange={handlePackageLogoFileChange}
        featureDetails={featureDetails}
        setFeatureDetails={setFeatureDetails}
        addSpecialtyRow={addSpecialtyRow}
        onChangeTags={onChangeTags}
        onChangeTier={onChangeTier}
        tagListOption={tagListOption}
        couponList={couponList}
        packageName={packageName}
        setPackageName={setPackageName}
        productCode={productCode}
        setProductCode={setProductCode}
        userType={userType}
        setUserType={setUserType}
        packageType={packageType}
        setPackageType={setPackageType}
        isFeatured={isFeatured}
        setIsFeatured={setIsFeatured}
        freeTrialType={freeTrialType}
        setFreeTrialType={setFreeTrialType}
        freeTrial={freeTrial}
        setFreeTrial={setFreeTrial}
        duration={duration}
        setDuration={setDuration}
        discountPrice={discountPrice}
        setDiscountPrice={setDiscountPrice}
        durationType={durationType}
        setDurationType={setDurationType}
        specialtyListOption={specialtyListOption}
        doctorListOption={doctorListOption}
        country={country}
        setCountry={setCountry}
        getAllDoctors={getAllDoctors}
        onSpecialityChange={onSpecialityChange}
        onCallChange={onCallChange}
        handleAllCheckedFreeDelivery={handleAllCheckedFreeDelivery}
        deliveryWelcomeNote={deliveryWelcomeNote}
        setDeliveryWelcomeNote={setDeliveryWelcomeNote}
        noOfFreeDelivery={noOfFreeDelivery}
        setNoOfFreeDelivery={setNoOfFreeDelivery}
        noOfFreeValue={noOfFreeValue}
        setNoOfFreeValue={setNoOfFreeValue}
        selectedTiers={selectedTiers}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        setSelectedTiers={setSelectedTiers}
        onCouponAdd={onCouponAdd}
        onRemoveCoupon={onRemoveCoupon}
        onGroupAdd={onGroupAdd}
        onGroupRemove={onGroupRemove}
        updateClaimField={updateClaimField}
        updatePolicyField={updatePolicyField}
        toggleClaimCheckbox={toggleClaimCheckbox}
        onDoctorChange={onDoctorChange}
        onDoctorCallChange={onDoctorCallChange}
        addDoctorRow={addDoctorRow}
        removeDoctorRow={removeDoctorRow}
        removeSpecialtyRow={removeSpecialtyRow}
        onSubmit={onSubmit}
        packagePrice={packagePrice}
        setPackagePrice={setPackagePrice}
        processing={processing}
        packageNameError={packageNameError}
        packageDurationError={packageDurationError}
        packagePriceError={packagePriceError}
        countryError={countryError}
        claimValueError={claimValueError}
        featureError={featureError}
        setCountryError={setCountryError}
        setPackageNameError={setPackageNameError}
        setPackageDurationError={setPackageDurationError}
        setPackagePriceError={setPackagePriceError}
        setClaimValueError={setClaimValueError}
        isLoading={isLoading}
        onCallUnlimitedChange={onCallUnlimitedChange}
      />
    </>
  );
};
export default EditCataloguePackage;
